<div *ngIf="show" class="picture-viewer-container">
  <div class="picture-viewer-inner" [ngClass]="{'width-adjust': isLongerImg}">
    <!-- <img *ngIf="images.length" [src]="images[current] + '?w=1200'" /> -->
    <div class="picture-viewer-scrollbar scroll-bar transparent"
      [ngClass]="{'fullHeight': isLongerImg}">
      <div *ngIf="!viewerImageLoaded" class="loader">
          <app-loader-spinner></app-loader-spinner>
      </div>
      <div class="picture-viewer-image" [ngClass]="{'longer': isLongerImg, 'loaded': viewerImageLoaded}">
          <img #pictureViewer class="picture-viewer-imgPath" [src]="images[current]" [ngClass]="{'longer': isLongerImg, 'wider': isWiderImg}">
      </div>
    </div>

    <div class="prev iconfont iconjiantou_liebiaoxiangzuo" (click)="prev()" [ngClass]="{ disable: current > images.length - 2 }">
    </div>
    <div class="next iconfont iconjiantou_liebiaoxiangyou" (click)="next()"
      [ngClass]="{ disable: current < 1 } "></div>
    <div class="close-button iconfont iconguanbi" (click)="close()"></div>
  </div>
</div>
